import axiosClient from "../axios-config";

export default {
  getLanguages() {
    return axiosClient.get('/languages');
  },
  getLanguagesUsed() {
    return axiosClient.get('/languages/languages_used');
  }
}